import { render, staticRenderFns } from "./ecosystem-co2-totals.vue?vue&type=template&id=0352289a&"
import script from "./ecosystem-co2-totals.ts?vue&type=script&lang=js&"
export * from "./ecosystem-co2-totals.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports